import Vue from 'vue';
import VueI18n from 'vue-i18n';
import de from './../locales/de.json';

Vue.use(VueI18n);

const numberFormats = {
    'de-CH': { currency: { style: 'currency', currency: 'CHF' } },
};

const i18n = new VueI18n({ locale: 'de', fallbackLocale: 'de', messages: { de }, numberFormats });

export default i18n;
